import { Injectable, signal } from '@angular/core';
import { PushToast, ToastItem } from '../models/toast.models';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private _id = 0;
  readonly toasts = signal<ToastItem[]>([]);

  push(toast: PushToast): number {
    const id = ++this._id;
    const item: ToastItem = { ...toast, duration: toast.duration ?? 4200, id };
    this.toasts.update(list => [...list, item]);
    if (item.duration > 0) {
      setTimeout(() => this.dismiss(id), item.duration);
    }
    return id;
  }

  dismiss(id: number): void {
    this.toasts.update(list => list.filter(t => t.id !== id));
  }

  success(title: string, body?: string): number {
    return this.push({ tone: 'success', title, body });
  }

  error(title: string, body?: string): number {
    return this.push({ tone: 'error', title, body });
  }

  info(title: string, body?: string): number {
    return this.push({ tone: 'info', title, body });
  }

  warn(title: string, body?: string): number {
    return this.push({ tone: 'warn', title, body });
  }
}
